<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import DefaultLayout       from './components/DashboardLayout.vue'
import ConsultationLayout  from '@/components/layouts/ConsultationLayout.vue'
import TriageLayout        from '@/components/layouts/TriageLayout.vue'
import FacilityAdminLayout from './components/layouts/FacilityAdminDashboardLayout.vue'
import PharmacyLayout      from './components/layouts/PharmacyDashboardLayout.vue'
import CashierLayout       from '@/components/layouts/CashierLayout.vue'
import EmptyLayout         from './components/layouts/EmptyLayout.vue'

const route = useRoute()

function getCurrentUserType() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || 'null')
    return user?.UserType || null
  } catch {
    return null
  }
}

const layoutComponent = computed(() => {
  const layout = route.meta.layout
  switch (layout) {
    case 'facility-admin': return FacilityAdminLayout
    case 'consultation':   return ConsultationLayout
    case 'triage':         return TriageLayout
    case 'pharmacy':       return PharmacyLayout
    case 'cashier':        return CashierLayout
    case 'empty':          return EmptyLayout
    default:
      return getCurrentUserType() === 'Facility Admin'
        ? FacilityAdminLayout
        : DefaultLayout
  }
})
</script>

<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
</template>
